import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { useLeads } from "../leads";
import { Loading } from "../ui";
import { Lead } from "./Lead";

interface IProps {
	accountId: number;
	handleChange: (selectedLeads: any[], actionType: any) => any;
	defaultValue: any;
}

export const LeadSelect = (props: IProps): ReactElement => {
	const [leads, setLeads] = useState([]);

	const leadContext = useLeads();

	useMemo(() => {
		const fetchLeads = async () => {
			const leadsData = await leadContext.fetchLeadsForAccount!(
				props.accountId,
			);
			setLeads(leadsData);
		};

		fetchLeads();
	}, []);

	if (!leads || !leads.length) {
		return <Loading />;
	}

	const options = leads.map((lead: Lead) => {
		return {
			value: lead.id,
			label: lead.fullName,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			isMulti={true}
			isClearable={false}
			onChange={(selectedLeads: any, actionType: any) => {
				props.handleChange(selectedLeads, actionType);
			}}
		/>
	);
};
